import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import apiClient from "../../apiClient";
import { Tab, Nav } from "react-bootstrap";
import { SSO_URL } from "../../env";
import {
  FETCH_APPLICATION_ENDPOINTS,
  FETCH_CHANNEL_APPLICATION_CONFIG,
  GET_CHANNEL_DETAILS,
} from "../../apiClient/apiEndpoints";
import { BackButton } from "../../assets/Icons";
import ChannelDetails from "../../pages/ChannelDetails";
import UpdateApplicationConfig from "../Application/UpdateApplicationConfig";
import EndpointVariable from "../Application/EndpointVariable";
import { getValueType } from "../../utils/general";

const ChannelApplicationsDetails = () => {
  const { channelId, applicationId } = useParams();
  const navigate = useNavigate();
  const [channelInfo, setChannelInfo] = useState({});
  const [endpointURL, setEndpointURL] = useState([]);
  const [activeData, setActiveTab] = useState("urls");
  const [configurationData, setConfigurationData] = useState({});

  const fetchChannelConfiguration = async () => {
    try {
      const data = await apiClient.get(`${SSO_URL}${FETCH_CHANNEL_APPLICATION_CONFIG}/${channelId}/${applicationId}`);
      setConfigurationData(data);
    } catch (error) {
      console.log(error);
    }
  };

  const fetchChannelDetails = async () => {
    try {
      const res = await apiClient.get(`${SSO_URL}${GET_CHANNEL_DETAILS}/${channelId}`);
      setChannelInfo(res);
    } catch (error) {
      console.log(error);
    }
  };

  const fetchURLS = async () => {
    try {
      const response = await apiClient.get(`${SSO_URL}${FETCH_APPLICATION_ENDPOINTS}/${channelId}/${applicationId}`);
      setEndpointURL(
        response?.filter((item) => {
          return item.type === "FRONTEND_URL";
        }) || []
      );
    } catch (error) {
      console.log(error);
    }
  };

  const initializePage = async () => {
    await Promise.all([fetchChannelConfiguration(), fetchChannelDetails(), fetchURLS()]);
  };

  useEffect(() => {
    initializePage();
  }, [channelId, applicationId]);

  const navTabToRender = configurationData?.defaultConfig?.filter(
    (item) => item.name !== "SMTP" && item.name !== "STORAGE" && item.name !== "ENV"
  );

  return (
    <div className="container-fluid m-0 pt-2 ">
      <div className="col-12">
        <button className="backbtn cursor-pointer mt-2" onClick={() => navigate(-1)} title="Back">
          <BackButton />
          Back
        </button>
      </div>
      <ChannelDetails details={channelInfo} />

      <div className="col-12">
        <Tab.Container activeKey={activeData} onSelect={(value) => setActiveTab(value)}>
          <div className="row mt-3">
            <div className="tabanddown">
              <Nav variant="pills" className="module-tab" activeKey={activeData}>
                <Nav.Item key="urls">
                  <Nav.Link eventKey="urls"> URLs </Nav.Link>
                </Nav.Item>

                {navTabToRender?.map((config) => {
                  return (
                    <Nav.Item key={config.id}>
                      <Nav.Link eventKey={config.name}>{config.name}</Nav.Link>
                    </Nav.Item>
                  );
                })}
              </Nav>
            </div>
          </div>

          <Tab.Content className="mt-3 mb-4">
            <Tab.Pane eventKey="urls" key="urls">
              <EndpointVariable endpointURL={endpointURL} fetchURLS={fetchURLS} />
            </Tab.Pane>

            {configurationData?.defaultConfig?.map((config) => {
              const defaultConfig = config;
              let existingConfig = {};
              if (config.name === "ENV") {
                existingConfig = configurationData?.environmentConfig[0] || {};
                existingConfig.data = configurationData?.environmentConfig[0]?.configuration || {};
              } else {
                existingConfig = configurationData?.config?.find((e) => e.type === config.name) || {};
              }

              const formattedConfigKeys = Object.entries(defaultConfig?.data || {}).map(([key, value]) => ({
                key,
                value,
                dataType: getValueType(value),
              }));

              const mergedConfigVariables = formattedConfigKeys?.map((item) => {
                if (item.key in (existingConfig?.data || {})) {
                  return {
                    key: item.key,
                    value: existingConfig?.data[item.key],
                    dataType: item.dataType,
                  };
                } else {
                  return item;
                }
              });

              const mergedConfig = {
                ...existingConfig,
                data: mergedConfigVariables,
              };

              return (
                <Tab.Pane eventKey={config.name} key={config.id}>
                  <UpdateApplicationConfig
                    applicationId={applicationId}
                    defaultConfig={{ ...defaultConfig, data: formattedConfigKeys }}
                    configData={mergedConfig}
                    defaultConfigMode={false}
                    isEnv={config.name === "ENV"}
                  />
                </Tab.Pane>
              );
            })}
          </Tab.Content>
        </Tab.Container>
      </div>
    </div>
  );
};

export default ChannelApplicationsDetails;
